var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 26.6667V3.33333C30.5 1.5 29 0 27.1667 0H3.83333C2 0 0.5 1.5 0.5 3.33333V26.6667C0.5 28.5 2 30 3.83333 30H27.1667C29 30 30.5 28.5 30.5 26.6667ZM10.3333 18.3L13.8333 22.5167L19 15.8667C19.3333 15.4333 20 15.4333 20.3333 15.8833L26.1833 23.6833C26.6 24.2333 26.2 25.0167 25.5167 25.0167H5.53333C4.83333 25.0167 4.45 24.2167 4.88333 23.6667L9.03333 18.3333C9.35 17.9 9.98333 17.8833 10.3333 18.3Z",
    fill: "#C4C4C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.ada84b97ff49e968bef4cc2baab07822.svg";
export { ForwardRef as ReactComponent };